import Resource from "../../../../src/components/resources";
import * as React from 'react';
export default {
  Resource,
  React
};